import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed5713fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SectorPanel" }
const _hoisted_2 = { class: "SectorPanel__header pb-4" }
const _hoisted_3 = { class: "SectorPanel__body pt-4" }
const _hoisted_4 = {
  key: 5,
  class: "flex items-center mt-3 mb-4"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "block select-none ml-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-brush mr-2" }, null, -1))
const _hoisted_8 = { class: "flex items-center justify-between mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        (!_ctx.isAddSector)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Редактирование "),
              _createElementVNode("b", null, _toDisplayString(_ctx.state.name), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Добавление сектора")
            ], 64))
      ]),
      _createElementVNode("p", null, [
        (_ctx.isCourierSector)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Сектор доставки")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Диспетчерский сектор")
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_input, {
        placeholder: "Название сектора",
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      (_ctx.isDispatcherSector)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 0,
            placeholder: "Описание сектора",
            class: "mt-2",
            value: _ctx.state.description,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.description) = $event)),
            "is-invalid": _ctx.state_form$.description.$error,
            "validation-errors": _ctx.state_form$.description.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      (!_ctx.isAddSector && _ctx.isDispatcherSector)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 1,
            value: _ctx.state.cityId,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.cityId) = $event)),
            placeholder: "Город",
            loading: _ctx.data_state.cities.is_loading,
            options: _ctx.data_state.cities.list,
            failed: _ctx.data_state.cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-by": "name",
            "select-by": "id",
            label: "name",
            "infinite-scroll": "",
            onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
            onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
            onSearch: _ctx.searchCity,
            onOptionBySearch: _ctx.unshiftFoundCity,
            class: "mt-3"
          }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]))
        : _createCommentVNode("", true),
      (!_ctx.isAddSector && _ctx.isDispatcherSector)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 2,
            value: _ctx.state.userIds,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.userIds) = $event)),
            placeholder: "Диспетчер",
            loading: _ctx.data_state.dispatchers.is_loading,
            options: _ctx.data_state.dispatchers.list,
            failed: _ctx.data_state.dispatchers.is_failed,
            "error-text": "При получении списка диспетчеров произошла ошибка",
            "search-by": "name",
            "select-by": "id",
            label: "name",
            "infinite-scroll": "",
            multiselect: "",
            searchable: false,
            onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadDispatchers(_ctx.data_state.dispatchers.pagination.current_page))),
            onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreDispatchers(_ctx.data_state.dispatchers.pagination.current_page + 1))),
            class: "mt-3"
          }, null, 8, ["value", "loading", "options", "failed"]))
        : _createCommentVNode("", true),
      (_ctx.isAddSector && _ctx.isCourierSector)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 3,
            placeholder: "Диспетчерский сектор",
            class: "mt-3",
            value: _ctx.state.dispatchers_sector_id,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.dispatchers_sector_id) = $event)),
            options: _ctx.data_state.dispatcher_sectors.list,
            loading: _ctx.data_state.dispatcher_sectors.is_loading,
            failed: _ctx.data_state.dispatcher_sectors.is_failed,
            "is-invalid": _ctx.state_form$.dispatchers_sector_id.$error,
            "validation-errors": _ctx.state_form$.dispatchers_sector_id.$errors,
            "error-text": "При получении секторов диспетчера произошла ошибка",
            onRefresh: _ctx.loadDispatcherSectors
          }, null, 8, ["value", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"]))
        : _createCommentVNode("", true),
      (!_ctx.isDispatcherSector && !_ctx.unfinishedSector)
        ? (_openBlock(), _createBlock(_component_color_picker, {
            key: 4,
            value: _ctx.state.color,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.color) = $event)),
            class: "mt-2"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.unfinishedSector))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "w-5 h-5 rounded opacity-70",
                style: _normalizeStyle({ backgroundColor: _ctx.unfinishedSector.color || '#2243B6' })
              }, null, 4),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.unfinishedSectorName), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAddSector && !_ctx.unfinishedSector)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 6,
            class: "primary small text mt-3 w-full",
            disabled: _ctx.isPaintStarted,
            onClick: _ctx.emitStartPaint
          }, {
            default: _withCtx(() => [
              (_ctx.isPaintStarted)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Обведите область на карте ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_7,
                    _createTextVNode(" Обвести область ")
                  ], 64))
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.isAddSector || (_ctx.isAddSector && !_ctx.isPaintStarted))
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              class: _normalizeClass(["second text small mr-2", { 'w-full': _ctx.isAddSector && !_ctx.unfinishedSector }]),
              onClick: _ctx.emitCancel
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(" Отмена ")
              ]),
              _: 1
            }, 8, ["onClick", "class"]))
          : _createCommentVNode("", true),
        (!_ctx.isAddSector || (_ctx.isAddSector && _ctx.unfinishedSector))
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              class: "primary text small",
              loading: _ctx.loading,
              onClick: _ctx.emitManager
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}